import axios from 'axios';
import { environment } from '@env';
import { getTokenFromStore } from '@utils';

const MG_URL = environment.API_URL;

const authURL = environment.TEST_AUTH_URL || `${MG_URL}auth`;
const userURL = `${MG_URL}user`;
const questionnaireURL = `${MG_URL}questionnaire`;
const answerURL = `${MG_URL}answer`;
const submissionURL = `${MG_URL}submission`;
const submissionGroupURL = `${MG_URL}submission-group`;
const roleURL = `${MG_URL}role`;
const unitURL = `${MG_URL}unit`;
const feedbackURL = `${MG_URL}feedback`;
const pdfURL = `${MG_URL}pdf`;
const permissionUrl = `${MG_URL}permission`;
const publicUrl = `${MG_URL}public`;
const originUrl = `${MG_URL}origin`;

export const authApi = axios.create({
  baseURL: authURL,
});

export const userApi = axios.create({
  baseURL: userURL,
});

export const questionnaireApi = axios.create({
  baseURL: questionnaireURL,
});

export const answerApi = axios.create({
  baseURL: answerURL,
});

export const submissionApi = axios.create({
  baseURL: submissionURL,
});

export const submissionGroupApi = axios.create({
  baseURL: submissionGroupURL,
});

export const roleApi = axios.create({
  baseURL: roleURL,
});

export const unitApi = axios.create({
  baseURL: unitURL,
});

export const feedbackApi = axios.create({
  baseURL: feedbackURL,
});

export const pdfApi = axios.create({
  baseURL: pdfURL,
});

export const permissionApi = axios.create({
  baseURL: permissionUrl,
});

export const publicApi = axios.create({
  baseURL: publicUrl,
});

export const originApi = axios.create({
  baseURL: originUrl,
});

[
  userApi,
  questionnaireApi,
  answerApi,
  submissionApi,
  submissionGroupApi,
  roleApi,
  unitApi,
  feedbackApi,
  pdfApi,
  permissionApi,
  publicApi,
  originApi,
].forEach((service) => {
  service.interceptors.request.use((config) => {
    config.headers['Authorization'] = 'bearer ' + getTokenFromStore();
    return config;
  });
});
